module.exports = __webpack_public_path__ + "static/media/teamviewer.7e6d1f69.png";